
import AppUtils from '../../control/apputlis';




export default class MRedux {

    static STATE_ACTRESS = "STATE_ACTRESS";
    static STATE_MARKS = "STATE_MARKS";
    static STATE_MOVIES = "STATE_MOVIES";
    static STATE_HOMEFLOWLIST = "STATE_HOMEFLOWLIST";

    static clearAllState() {
        // MRedux.saveState(MRedux.STATE_ACTRESS, '');
        // MRedux.saveState(MRedux.STATE_MARKS, '');
        // MRedux.saveState(MRedux.STATE_MOVIES, '');
        // MRedux.saveState(MRedux.STATE_HOMEFLOWLIST, '');
        window.sessionStorage.clear();
    }

    static recoverState(name, state) {
        let ttstate = window.sessionStorage.getItem(name);
        if (ttstate) {
            ttstate = JSON.parse(ttstate);
            if (ttstate) {
                for (var val in ttstate) {
                    state[val] = ttstate[val];
                }
            }
        }
    }

    static saveState(name, state) {
        window.sessionStorage.setItem(name, JSON.stringify(state))
    }
}